export default __webpack_public_path__ + "static/media/TVSraider_LateralDer.5134e572.webp";